import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { Router } from '@angular/router';
import { UploadsConfigService } from 'src/app/service/uploadsconfig.service';
import { UploadsConfigModel } from 'src/app/models/upload/uploadsconfig.model';
import { GlobalService } from 'src/app/service/global.service';
import { extractApiErrorMessage } from '../upload-template.util';

@Component({
  selector: 'app-uploads-view',
  templateUrl: './uploads-view.component.html',
  styleUrls: ['./uploads-view.component.css']
})
export class UploadsViewComponent implements OnInit, OnDestroy {

  public uploadsConfigModel = new UploadsConfigModel();
  public refreshing = false;
  public loggedinUser = '';
  actionButtons: { name: string; class: string }[];

  myDocsData: UploadsConfigModel[] = [];
  ordersTableExcelHeaderColumns: TableColumn[];
  ordersTableColumns1: TableColumn[];
  actions: { name: string; dataKey: string; position: string; isSortable: boolean; class: string }[];
  myUploadsSet = new Set<string>();
  isAccessDisabled = false;

  private subscriptions: Subscription[] = [];

  constructor(
    private globalService: GlobalService,
    private router: Router,
    private httpService: HttpClient,
    private uploadsConfigService: UploadsConfigService,
    public ete: ExportExcelService,
    private authGaurdService: AuthGaurdService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.isAccessDisabled = this.globalService._permissionCheck('uploads-view');
    this.loggedinUser = this.authGaurdService.loginUser();
    this.initializeColumns();
    this.initializeExcelHeaders();
    this.getTemplatesList();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  public getTemplatesList(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.uploadsConfigService.getTemplatesList().subscribe(
        (response: UploadsConfigModel[]) => {
          this.myDocsData = response.sort((a, b) => a.uploadtemplatename.localeCompare(b.uploadtemplatename));
          this.refreshing = false;
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
          this.refreshing = false;
        }
      )
    );
  }

  initializeExcelHeaders(): void {
    this.subscriptions.push(
      this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(data => {
        this.ordersTableExcelHeaderColumns = data['UploadsConfig'];
      })
    );
  }

  exportExcel(): void {
    const rows = this.myDocsData.map(row => ({
      'Upload Template': row.uploadtemplatename,
      'Record Template': row.recordtemplate,
      'Insert/Update': row.actiontype,
      'Description': row.uploadtemplatedesc
    }));
    this.ete.exportFromJsonRows(rows, 'UploadsConfigTemplate');
  }

  updateUploadsConfig(
    uploadtemplatename: string,
    uploadtemplatedesc: string,
    recordtemplate: string,
    actiontype: string,
    transformationroutine: string,
    sqlquery: string
  ): void {
    this.uploadsConfigModel.uploadtemplatename = uploadtemplatename;
    this.uploadsConfigModel.uploadtemplatedesc = uploadtemplatedesc;
    this.uploadsConfigModel.recordtemplate = recordtemplate;
    this.uploadsConfigModel.actiontype = actiontype;
    this.uploadsConfigModel.transformationroutine = transformationroutine;
    this.uploadsConfigModel.sqlquery = sqlquery;
    this.uploadsConfigService.uploadsConfigModel = this.uploadsConfigModel;
    this.uploadsConfigService.myUploadsSet = this.myUploadsSet;
    this.router.navigate(['/uploads-edit'], {
      queryParams: { recordtemplate, uploadtemplatename }
    });
  }

  downloadExcelHeaders(recordtemplate: string, actiontype: string = 'Insert'): void {
    const fileTitle = actiontype === 'Update' ? 'UploadsConfig_Update' : 'UploadsConfig_Insert';
    this.subscriptions.push(
      this.uploadsConfigService.getRecordsListForAction(recordtemplate, actiontype || 'Insert').subscribe(
        (response: UploadsConfigModel[]) => {
          this.ete.exportHeaderOnlyTemplate(fileTitle, response);
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
        }
      )
    );
  }

  rowAction(row: { row: UploadsConfigModel; value: string }): void {
    if (row.value === 'Download') {
      this.downloadExcelHeaders(row.row.recordtemplate, row.row.actiontype);
    } else if (row.value === 'Update') {
      this.updateUploadsConfig(
        row.row.uploadtemplatename,
        row.row.uploadtemplatedesc,
        row.row.recordtemplate,
        row.row.actiontype,
        row.row.transformationroutine,
        row.row.sqlquery
      );
    }
  }

  actionOnButton(action: string): void {
    if (action === 'Add') {
      if (this.isAccessDisabled) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.redirect('uploads-create');
      }
    }
  }

  redirect(url: string): void {
    this.router.navigate(['/' + url]);
  }

  initializeColumns(): void {
    this.subscriptions.push(
      this.httpService.get('../../../assets/json/tableColumns.json').subscribe(data => {
        this.ordersTableColumns1 = data['UploadsConfigTemplate'];
      })
    );
    this.actions = [
      { name: 'Update', dataKey: 'fas fa-edit success f-25', position: 'left', isSortable: false, class: 'badge bg-danger' },
      { name: 'Download', dataKey: 'fas fa-download success f-25', position: 'left', isSortable: false, class: 'badge bg-danger' }
    ];
    this.actionButtons = [{ name: 'Add', class: 'btn btn-success btn-xs' }];
  }
}
